import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { UseCase } from "../../base/use-case";
import { AddEditLocationRequest, Location } from "../../domain";
import { LocationsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class EditLocationUsecase implements UseCase<AddEditLocationRequest, boolean> {

  constructor(private locationRepository: LocationsRepository) {
  }

  execute(params: AddEditLocationRequest): Observable<boolean> {
    return this.locationRepository.editLocation(params);
  }

}
